export const formDataCreator = (
  payload: FormData,
  wholesaler: IWholesalerAddInfo | undefined,
) => {
  wholesaler?.title && payload.append('title', wholesaler?.title);
  payload.append('profile_type', 'market');
  wholesaler?.subProduct &&
    payload.append('subproduct', wholesaler?.subProduct);
  wholesaler?.existing && payload.append('existing', wholesaler?.existing);
  wholesaler?.existing_unit &&
    payload.append('existing_unit', wholesaler?.existing_unit);
  wholesaler?.state && payload.append('state', wholesaler?.state);
  wholesaler?.city && payload.append('city', wholesaler?.city);
  wholesaler?.description &&
    payload.append('description', wholesaler?.description);
  wholesaler?.hide_phone_number &&
    payload.append('hide_phone_number', `${wholesaler?.hide_phone_number}`);
  wholesaler?.type && payload.append('type', wholesaler?.type);
  if (wholesaler?.images && wholesaler?.images?.length > 0) {
    const mainImage = wholesaler.images?.find(x => x.isSelected)?.file;
    if (mainImage) {
      payload.append('main_image', mainImage);
    }
    wholesaler?.images.map(item => payload.append('images', item.file));
  }
  return payload;
};
